import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.replace.js";
import { useLocation, useHistory } from 'react-router';
import queryparse from 'tricks/string/queryparse';
import createLocation from 'utils/createLocation';

// the parameters needed to fetch asset data from the server

// A hook that listens for the url-query to contain a parameter 'asset' and then displays it.
function useAssetViewerQueryParams(assetParamName) {
  var location = useLocation();
  var history = useHistory();
  var search = location.search;
  var _queryparse = queryparse(search),
    assetId = _queryparse[assetParamName],
    isPublished = _queryparse.isPublished,
    playlistId = _queryparse.playlistId;
  var params = {
    isPublished: isPublished && isPublished !== 'false',
    playlistId: playlistId && +playlistId,
    assetId: assetId && +assetId
  };
  function removeQueryParams() {
    history.replace(createLocation(location, _defineProperty({
      playlistId: undefined,
      isPublished: undefined
    }, assetParamName, undefined)));
  }
  return [params, removeQueryParams];
}
export default useAssetViewerQueryParams;